const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/cm/coach-list/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/cm/coach-list/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}